<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">分类名称</div>
            <el-input v-model="edit_Name" placeholder="请输入分类名称" ></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">排序</div>
            <el-input v-model="edit_sort" placeholder="请输入排序" ></el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">状态</div>
              <el-select v-model="edit_status" placeholder="请选择状态" @change="changeStatus" style="width:100%">
                <el-option
                    v-for="item in status2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
          </el-col>
        </el-row>


      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">确认</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      edit_Name:'',
      edit_sort:'',

      status2: [{
          value: 1,
          label: '正常'
      }, {
          value: 2,
          label: '禁用'
      }],
      edit_status: -1,

      activityClassCode:'',


    }
  },
  methods: {
    init(row){

      this.edit_Name = row.name;
      this.edit_sort = row.sort;
      this.edit_status = row.status;

      this.activityClassCode = row.activityClassCode;

    },

    closeSelf() {
      //this.loading= false
      this.$emit("closeEdit");
    },

    confirm(){

      if(this.edit_Name === ''){
        this.$message("输入名称");
        return;
      }
      if(this.edit_sort === ''){
        this.$message("输入排序");
        return;
      }
      if(this.edit_status === -1){
        this.$message("选择状态");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityClass/GovEdit',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          //governmentCode: getGovernmentCode(),
          name: this.edit_Name,
          sort:this.edit_sort,
          status:this.edit_status,
          activityClassCode:this.activityClassCode,
        }
      }).then( (response)=> {
        //console.log(response)
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeEdit");
          this.$emit("getList");
          //this.$message('修改成功！');
        }else{
          this.$message(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


    changeStatus:function (selVal) {
      this.edit_status = selVal;
    },



  }
}
</script>

